import axios from 'axios';
import authHeader from "@/service/auth-header";

class MessageSchedulerService {

    async getCompanyMessageSchedulings(companyId) {
        return await axios.get(`/api/messagescheduler/${companyId}`, {headers: authHeader()})
    }

    async processMessageScheduling(id) {
        return await axios.post(`/api/messagescheduler/${id}`, null, {headers: authHeader()});
    }

    async completeMessageScheduling(id) {
        return await axios.post(`/api/messagescheduler/complete/${id}`, null, {headers: authHeader()});
    }

}

export default new MessageSchedulerService();
